/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notify_PrepInputs */

const en_notify_prep = /** @type {(inputs: Notify_PrepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prep ahead`)
};

const de_notify_prep = /** @type {(inputs: Notify_PrepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorbereiten`)
};

/**
* | output |
* | --- |
* | "Prep ahead" |
*
* @param {Notify_PrepInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const notify_prep = /** @type {((inputs?: Notify_PrepInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notify_PrepInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_notify_prep(inputs)
	return en_notify_prep(inputs)
});